module.exports = __webpack_public_path__ + "img/user.35c0d598.svg";